import i18n from '@/i18n';

const DATE_LOCALES: Record<string, string> = { uz: 'uz', ru: 'ru-RU', en: 'en-US' };
const NUMBER_LOCALES: Record<string, string> = { uz: 'uz-UZ', ru: 'ru-RU', en: 'en-US' };

/** Locale for date/time formatting that follows the current UI language. */
export const dateLocale = (): string => DATE_LOCALES[i18n.language] ?? 'uz';

/** Locale for number formatting that follows the current UI language. */
export const numberLocale = (): string => NUMBER_LOCALES[i18n.language] ?? 'uz-UZ';
